<style lang="less" rel="stylesheet/less" scope>
  .login-comtainer {
    min-width: 350px;
    width: 350px;
    vertical-align: middle;
    margin-top: 30px;
    border: 1px solid #b6b6b6;
    position: absolute;
    top: 0;
    right: 10%;
    z-index: 99;
    .title {
      margin: 0px auto 20px auto;
      font-size: 20px;
      text-align: center;
      color: #666;
    }
    .login-form {
      padding: 35px 35px 35px 35px;
      .el-checkbox__input {
        line-height: 0;
      }
      .el-checkbox__inner {
        width: 14px;
        height: 14px;
        border-radius: 3px;
        &:after {
          left: 3px;
          top: -1px;
        }
      }
      .el-checkbox__label {
        font-size: 12px;
      }
    }
    .form-margain-password {
      margin-bottom: 0;
      margin-top: 5px;
    }
    .recover {
      position: absolute;
      right: 0;
      font-size: 12px;
      color: #007cfe;
      text-decoration: underline;
    }
    .vcode-img {
      width: 100%;
    }
    .change-image {
      font-size: 12px;
      cursor: pointer;
    }
  }
  .error-msg{color:red;}
  @media screen and (max-width: 1920px) {
    .login-comtainer {
      min-height: 300px!important;
      margin-top: 15px;
      .title {
        margin-bottom: 8px;
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .login-comtainer {
      min-height: 300px!important;
      margin-top: -5px;
      .login-form {
        padding: 20px 35px;
      }
      .title {
        margin-bottom: 8px;
      }
    }
  }
  @media screen and (max-width: 1030px) {
    .login-comtainer {
      min-height: 270px!important;
      width:240px;
      min-width: 200px;
      margin-left: 40px;
      box-sizing: border-box;
      margin-top: -5px;
      .login-form {
        padding: 15px;
      }
      .title {
        margin-bottom: 6px;
      }
    }
  }
</style>
<template>
  <div class="login-comtainer">
    <el-form class="card-box login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left">
      <h3 class="title" style="margin-bottom:15px;">登录</h3>
      <el-form-item prop="username">
        <el-input name="username" type="text" v-model="loginForm.username" autoComplete="on" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input name="password" type="password" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item v-show="false" prop="time">
        <el-input name="time" type="text"  v-model="loginForm.time" autoComplete="on" placeholder="时间"></el-input>
      </el-form-item>
      <el-form-item prop="vcode" v-if="isVcode||showCode" class="form-margain-password">
        <el-col :span="10">
          <el-input name="vcode" type="text" @keyup.enter.native="handleLogin" v-model="loginForm.vcode" autoComplete="on" placeholder="验证码"></el-input>
        </el-col>
        <el-col :span="10">
          <img :src="vcodeSrc" class="vcode-img">
        </el-col>
        <el-col :span="4">
          <span class="change-image" @click="changeImage">看不清</span>
        </el-col>
      </el-form-item>
      <span class="error-msg">{{errorMsg}}</span>
      <el-form-item class="form-margain-password">
        <el-checkbox label="记住用户名" name="type" v-model="isRember" checked></el-checkbox>
        <a class="recover" :href="recoverUri" target="_black">忘记密码</a>
      </el-form-item>
      <el-button type="primary" style="width:100%;margin-top:15px;" :loading="loading" @click.native.prevent="handleLogin">登录</el-button>
    </el-form>
    <form action="" id="myForm" v-show="false" ref="myForm" method="post">
      <input type="text" name="state" v-model="formdata.state">
      <input type="text" name="clientId" v-model="formdata.clientId">
      <input type="text" name="redirectUri" v-model="formdata.redirectUri">
      <input type="submit" id="submitBtn">
    </form>
  </div>
</template>
<script type='text/ecmascript-6'>

  export default {
    name: 'loginBoardNormal',
    data () {
      return {
        loading: false,
        isRember: true,
        isVcode: false,
        loginForm: {
          username: '',
          password: '',
          time:'',
          vcode:''
        },
        loginRules: {
          username: [{ required: true, message: '请输入用户名', trigger: 'blur'}],
          password: [{ required: true, message: '请输入密码', trigger: 'blur'}],
          vcode: [{ required: true, message: '请输入验证码', trigger: 'blur'}]
        },
        formdata: {
          clientId: 'iportal_client',
          state: '',
          redirectUri: this.$store.getters.objApi.LOCAL_URL+'/#/platform',
        },
        vcodeSrc: this.$store.getters.objApi.OAUTH_API + "login/vcode?date="+new Date(),
        errorMsg: '',
      }
    },
    computed: {
      showCode() {
        return this.$store.getters.objApi.showCode;
      },
      recoverUri() {
        let href = window.location.href;
        let index = href.indexOf('/login');
        return href.substr(0, index) + '/recover';
      }
    },
    created() {
      if (localStorage.isRember) {
        this.loginForm.username = localStorage.isRember;
      }
    },
    methods: {
      handleLogin() {
        let time=new Date().getTime();
        this.loginForm.time=time;
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true;
            const vm = this;
            if (vm.isRember) {
              localStorage.isRember = this.loginForm.username;
            }
            this.$store.dispatch('LoginByUsername', this.loginForm).then((data) => {
              this.loading = false;
              this.formdata.state = data.state;
              this.$refs.myForm.action = this.$store.getters.objApi.OAUTH_API + 'auth/implicit/token';
              this.$nextTick(function () {
                vm.$refs.myForm.submit();
              })
            }).catch((err) => {
              this.loading = false;
              this.errorMsg = err.data.error;       
              this.changeImage();
              if(err.data.failLoginCount >= 2) {
                this.isVcode = true;
              }
            })
          } else {
            return false
          }
        })
      },
      changeImage() {
        this.vcodeSrc = this.$store.getters.objApi.OAUTH_API + "login/vcode?date="+new Date();
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/login/components/login-normal.vue